export const dayOfWeek = () => {
  const weekdays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  const date = new Date();
  const day = date.getDay();
  return weekdays[day];
}
